import {asset} from 'imba';
import url from './square_small.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H48V48H0V0ZM13 12C12.4477 12 12 12.4477 12 13V35C12 35.5523 12.4477 36 13 36H35C35.5523 36 36 35.5523 36 35V13C36 12.4477 35.5523 12 35 12H13Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})